/* ============
 * Mutation types for the alert module
 * ============
 *
 * The mutation types that are available
 * on the alert module.
 */
import keyMirror from 'key-mirror';

export default keyMirror({
  SET_ALERTS: null,
  PERSIST_ALERT: null,

  FETCH_ALERTS: null,
  FETCH_ALERTS_SUCCESS: null,
  FETCH_ALERTS_FAIL: null,

  UPDATE_ALERT: null,
  UPDATE_ALERT_SUCCESS: null,
  UPDATE_ALERT_FAIL: null,

  RESOLVE_ALERT: null,
  RESOLVE_ALERT_SUCCESS: null,
  RESOLVE_ALERT_FAIL: null,

  FETCH_RESOLVED_NOTES: null,
  FETCH_RESOLVED_NOTES_SUCCESS: null,
  FETCH_RESOLVED_NOTES_FAIL: null
});
